export const isKeyboardEventType = (e: unknown): e is KeyboardEvent => !!e && typeof e === 'object' && 'key' in e;
